<template>
    <div class="form-item" v-show="item.visible">
        <el-tooltip class="item" effect="dark" placement="top-start" v-if="item.description">
            <div slot="content">
                {{item.description}}
            </div>
            <img class="form-tooltip" :src="require('@/assets/question.png')"/>
        </el-tooltip>
        <el-form-item :label="localized(`label`)" :rules="rules" :prop="item.prop">
            <el-input type='textarea' v-model="itemdata" :autosize="{ minRows: 2}"  :disabled="!item.editable" :placeholder="localized(`prompt`)" @focus="showInputView"></el-input>
        </el-form-item>

		<el-dialog
		:title="localized(`label`)"
		:visible.sync="showInputArea"
		top="15vh"
		class="input-dialog"
		width="90%">
			<el-input type='textarea' v-model="tempData" :autosize="{ minRows: 4}"  :disabled="!item.editable" :placeholder="localized(`prompt`)" ref="inputRef"  :autofocus="true" style="margin-top: -20px;"></el-input>
			<el-row type="flex" class="row-bg" justify="space-between" style="margin-top: 20px;">
				<el-col :span="11">
					<el-button @click="rollbackData"
							size="small"
							round
							class="btn-white-color">{{$t('app.btn_clear')}}</el-button>
				</el-col>
				<el-col :span="11">
					<el-button @click="confirmData"
							size="small"
							round
							class="btn-white-color">{{$t('app.btn_confirm')}}</el-button>
				</el-col>
			</el-row>
		</el-dialog>
    </div>
</template>


<script>
	import utils from '@/utils'
	import language from '@/lang'
	// import utils from '../utils'
	import callApp from '@/services/sdk'
	export default {
		name: 'input-textarea-widget',
		props: {
			editable: { type: Boolean },
			item: { type: Object },
			value: { type: String }
		},
		data() {
			return {
				rules: utils.generateFormRule(this.item),
				showInputArea: false,
				tempData: ""
			}
		},
		computed: {
			itemdata: {
				get() { return this.value },
				set(itemdata) { 
					this.$emit('input', itemdata) 
					}
			}
		},
    methods: {
			callApp(type) {
        if (!this.item.editable){
					return
				}
				if (type === 'qrcode') {
					callApp('getQrcodeContent', {}, 'cbGetQrcodeContent')
						.then(data => {
							this.itemdata = data
						})
				}
			},
			localized(key){
				return language.localize(this.$store.state,this.item.name, key, this.item[key])
			},
			showInputView() {
				
				this.showInputArea = true
				this.tempData = this.itemdata
				this.$nextTick(()=>{
					this.$refs["inputRef"].focus()
				})
			},
			confirmData() {
				this.showInputArea = false
				this.itemdata = this.tempData
			},
			rollbackData() {
				this.showInputArea = false
				this.tempData = this.itemdata
			}
	},
	created() {
		if (this.value != undefined) {
			if (typeof(this.value) == 'string' && this.value.length > 0) {
				this.itemdata = this.value
			}else{
				this.itemdata = this.item.defaultValue
			}
		}else{
			this.itemdata = this.item.defaultValue
		}
	}
	}
</script>

